import {
  Competency_Map_Status,
  OrderType,
  PlatformCompetencyMapListOrderFields,
  useCompetencyMapsLazyQuery,
} from "@generated/graphql";
import { Stack } from "@mui/material";
import ROUTES from "constants/routes";
import useSetTabTitle from "hooks/useSetTabTitle";
import TableConstructor from "layout/TableConstructor";
import { RouteEnum, TableConstructorTab } from "layout/TableConstructor/types";
import Header from "pages/CompetencyMaps/list/components/Header";
import getColumnConfig, { CompetencyMapItem } from "pages/CompetencyMaps/list/tableConfig/columnConfig";
import filterFields, { CompetencyMapFilters } from "pages/CompetencyMaps/list/tableConfig/filterFields";
import { useNavigate } from "react-router-dom";

const tabs: TableConstructorTab[] = [
  { title: "Текущие", id: "1", filter: {} },
  {
    title: "Архив",
    id: "2",
    filter: { status: Competency_Map_Status.Archive },
    emptyPlaceholderText:
      "Здесь будут карты, перемещённые в архив. Архив позволяет временно выключить карту без её удаления.",
  },
];

const CompetencyMapsList = () => {
  const navigate = useNavigate();

  const defaultOrder = {
    field: PlatformCompetencyMapListOrderFields.CreatedAt,
    order: OrderType.Desc,
  };

  const [fetchCompetencyMaps, { data, loading, refetch }] = useCompetencyMapsLazyQuery();

  const list = data?.competencyMaps.data || [];

  useSetTabTitle("Карты компетенций");

  return (
    <Stack spacing={2.5}>
      <Header refetch={refetch} />
      <TableConstructor<
        CompetencyMapItem,
        CompetencyMapFilters,
        PlatformCompetencyMapListOrderFields,
        undefined,
        RouteEnum.CompetencyMap
      >
        storageName='competencyMap'
        settingsModalTitle='Список карт компетенций'
        exportRoute={RouteEnum.CompetencyMap}
        initialFetch={data ? null : fetchCompetencyMaps}
        tabs={tabs}
        refetch={refetch}
        data={list}
        totalCount={data?.competencyMaps.totalCount}
        loading={loading}
        columnsConfig={getColumnConfig(refetch)}
        filtersConfig={filterFields}
        defaultOrder={defaultOrder}
        defaultVisibleColumnList={[
          "title",
          "createdAt",
          "specialization",
          "grades",
          "updatedAt",
          "competencesCount",
          "action",
        ]}
        emptyPlaceholderText='Пока нет карт компетенций'
        onRowClick={(row) => navigate(`/${ROUTES.COMPETENCE_MAPS}/view/${row.id}`)}
      />
    </Stack>
  );
};

export default CompetencyMapsList;
